module.exports = __webpack_public_path__ + "img/huilv.d118f056.png";